const ImageUrl = 'https://api.b2bleads.in';
//const ImageUrl='http://localhost:8000';
export { ImageUrl }